export class EndPointConstants {

    static readonly FSGetCandidateDetails = 'FileSubmission/GetCandidate?loginUserId=';
    static readonly FSSaveCandidateDetails = 'FileSubmission/SaveCandidate';
    static readonly FSCurrentAddressDetails = 'FileSubmission/SaveCurrentAddress?loginUserId=';
    static readonly FSGetCandidateClientDetails = 'FileSubmission/GetCandidateClient?caseNo=';
    static readonly FSSaveCandidateClientDetails = 'FileSubmission/SaveCandidateClient';
    static readonly FSGetClientScreeningDetails = 'FileSubmission/GetScreeningDetails';
    static readonly FSSaveClientScreeningDetails = 'FileSubmission/SaveScreeningDetails';
    static readonly FSGetScreeningDetails = 'FileSubmission/GetScreeningCaseComponent';
    static readonly FSGetScreeningCompDetails = 'FileSubmission/GetAllComponentDetails';
    static readonly FSSaveScreeningCompDetails = 'FileSubmission/SaveScreeningDetails'
    static readonly FSGetLoaDocumentDetails = 'FileSubmission/GetLoaDocument?caseNo='
    static readonly FSSaveLoaDocumentDetails = 'FileSubmission/SaveLoaDocument'
    static readonly FSSaveInvitationDetail = 'FileSubmission/SaveInvitationDetail'
    static readonly FSGetReviewDetails = 'FileSubmission/GetReview?caseNo='
    static readonly FSGetGapReasonDetails = 'FileSubmission/GetGapReason?screeingId='
    static readonly FSGetGapEduReasonDetails = 'FileSubmission/GetEducationDurationDetails?screeningId='
    static readonly FSGetGapEmpReasonDetails = 'FileSubmission/GetEmployeeDurationDetails?screeningId='
    static readonly FSDirectAppAutoCreateComponents = 'FileSubmission/SaveDirectAppAutoCreateComponent?loginUserId=';
}


